/**
 * Genre data and emoji mapping.
 * Preserved from v1.
 */

export const ALL_GENRES = [
  { id: 28, name: 'Action' }, { id: 10759, name: 'Action-adventure' },
  { id: 12, name: 'Adventure' }, { id: 16, name: 'Animation' },
  { id: 35, name: 'Comedy' }, { id: 80, name: 'Crime' },
  { id: 99, name: 'Documentary' }, { id: 18, name: 'Drama' },
  { id: 10751, name: 'Family' }, { id: 14, name: 'Fantasy' },
  { id: 36, name: 'History' }, { id: 27, name: 'Horror' },
  { id: 10762, name: 'Kids' }, { id: 10402, name: 'Music' },
  { id: 9648, name: 'Mystery' }, { id: 10763, name: 'News' },
  { id: 10764, name: 'Reality' }, { id: 10749, name: 'Romance' },
  { id: 878, name: 'Science fiction' }, { id: 10765, name: 'SciFi/Fantasy' },
  { id: 10766, name: 'Soap' }, { id: 10767, name: 'Talk' },
  { id: 53, name: 'Thriller' }, { id: 10770, name: 'TV Movie' },
  { id: 10752, name: 'War' }, { id: 10768, name: 'War politics' },
  { id: 37, name: 'Western' },
];

export const DEFAULT_EXCLUDED_GENRES = new Set([99, 10763, 10764, 10767]);

export function getDefaultExcludedGenres() {
  return new Set(DEFAULT_EXCLUDED_GENRES);
}

export const GENRE_NAME = Object.fromEntries(ALL_GENRES.map(g => [g.id, g.name]));

export const GENRE_EMOJIS = [
  {id:37,emoji:'\u{1F920}'},{id:10752,emoji:'\u{1FA96}'},{id:16,emoji:'\u{1F3A8}'},{id:'anime',emoji:'\u{1F3A8}'},
  {id:10402,emoji:'\u{1F3B6}'},{id:'musical',emoji:'\u{1F3B6}'},{id:'superhero',emoji:'\u{1F9B8}\u200D\u2642\uFE0F'},
  {id:'dc comics',emoji:'\u{1F9B8}\u200D\u2642\uFE0F'},{id:'marvel cinematic universe (mcu)',emoji:'\u{1F9B8}\u200D\u2642\uFE0F'},
  {id:'pirate',emoji:'\u{1F3F4}\u200D\u2620\uFE0F'},{id:'kung fu',emoji:'\u{1F94B}'},{id:'ghost',emoji:'\u{1F47B}'},
  {id:'vampire',emoji:'\u{1F9DB}\u{1F3FB}\u200D\u2642\uFE0F'},{id:'zombie',emoji:'\u{1F9DF}\u200D\u2642\uFE0F'},{id:'halloween',emoji:'\u{1F383}'},
  {id:'magic',emoji:'\u{1FA84}'},{id:27,emoji:'\u{1F631}'},{id:9648,emoji:'\u{1F50D}'},
  {id:'space opera',emoji:'\u{1F6F8}'},{id:'space',emoji:'\u{1F6F8}'},{id:'time travel',emoji:'\u231B'},
  {id:'dream',emoji:'\u{1F4AD}'},{id:'heist',emoji:'\u{1F4B0}'},{id:'wall street',emoji:'\u{1F4B0}'},
  {id:'alien',emoji:'\u{1F47D}'},{id:'robot',emoji:'\u{1F916}'},{id:'video game',emoji:'\u{1F47E}'},
  {id:'sports',emoji:'\u{1F3C5}'},{id:'high school',emoji:'\u{1F392}'},{id:'spy',emoji:'\u{1F52B}'},
  {id:'hitman',emoji:'\u{1F52B}'},{id:'gangster',emoji:'\u{1F52B}'},{id:'assassin',emoji:'\u{1F52B}'},
  {id:'buddy cop',emoji:'\u{1F693}'},{id:'fashion',emoji:'\u{1F460}'},{id:'journalism',emoji:'\u{1F4F0}'},
  {id:'dinosaur',emoji:'\u{1F996}'},{id:'road trip',emoji:'\u{1F697}'},{id:878,emoji:'\u{1F6F8}'},
  {id:14,emoji:'\u{1F409}'},{id:36,emoji:'\u{1F4D6}'},{id:53,emoji:'\u{1F52A}'},{id:99,emoji:'\u{1F3A5}'},
  {id:10751,emoji:'\u{1F46A}'},{id:80,emoji:'\u26D3'},{id:10749,emoji:'\u{1F49E}'},{id:35,emoji:'\u{1F923}'},
  {id:28,emoji:'\u{1F4A5}'},{id:12,emoji:'\u{1F3D4}'},{id:18,emoji:'\u{1F3AD}'},{id:10770,emoji:'\u{1F4FA}'},
];

export function getFilmEmoji(genres, keywords) {
  const combined = (keywords || []).concat(genres || []);
  for (const g of GENRE_EMOJIS) { if (combined.includes(g.id)) return g.emoji; }
  return '\u{1F37F}';
}
